import { render, staticRenderFns } from "./PaymentV2.vue?vue&type=template&id=bf2b0e4c&"
import script from "./PaymentV2.vue?vue&type=script&lang=js&"
export * from "./PaymentV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports